import React, { ReactNode } from 'react'
import { Box } from '@material-ui/core'
import { Alert, AlertColor } from '@mui/material'
import Avatar from '@mui/material/Avatar'
import CMSText, { prismicText } from '@/components/Global/CMSText'
import { ImageField, RichTextField } from '@prismicio/types'
import { evaluateCondition } from '@/utils/evaluateCondition'

type TProductDynamicAlertProps = {
  text?: RichTextField
  color?: string
  icon?: string | ImageField
  condition?: string | RichTextField
  data?: unknown
}

const ALERT_COLORS: AlertColor[] = ['success', 'info', 'warning', 'error']

const resolveSeverity = (value?: string): AlertColor => {
  if (!value) return 'info'
  const lowerCased = value.toLowerCase()
  return ALERT_COLORS.includes(lowerCased as AlertColor)
    ? (lowerCased as AlertColor)
    : 'info'
}

const resolveAlertIcon = (icon?: string | ImageField, label = 'alert-icon') => {
  if (!icon) return undefined
  if (typeof icon === 'string') return <span>{icon}</span>
  if (icon?.url) return <Avatar src={icon.url} alt={icon.alt || label} />
  return undefined
}

const ProductDynamicAlert = ({
  text,
  color,
  icon,
  condition,
  data,
}: TProductDynamicAlertProps) => {
  if (!text?.length) return null

  const severity = resolveSeverity(color)
  const shouldDisplay = evaluateCondition(condition, { data: data || {} })
  if (!shouldDisplay) return null

  const alertIcon: ReactNode = resolveAlertIcon(icon, prismicText(text))

  return (
    <Box mt={2} className="product-dynamic-alert">
      <Alert
        severity={severity}
        icon={alertIcon}
        className="product-dynamic-alert__content"
      >
        <CMSText data={text} />
      </Alert>
    </Box>
  )
}

export default ProductDynamicAlert
